import { apiGet, USE_MOCK_API } from './httpClient'

export interface StoryPoint {
  id: string
  title: string
  type: string
  date: string | null
  day_index: number
  address: string
  description: string
  status: string
  lat: number | null
  lng: number | null
}

export interface StoryMedia {
  id: string
  point_id: string | null
  type: string
  url: string
  date: string | null
  location: string
}

export interface StoryStats {
  day_count: number
  place_count: number
  photo_count: number
  country_count: number
}

export interface Story {
  trip_id: string
  slug: string
  title: string
  description: string
  destination: string
  start_date: string | null
  end_date: string | null
  cover_url: string | null
  points: StoryPoint[]
  media: StoryMedia[]
  stats: StoryStats
}

const MOCK_STORY: Story = {
  trip_id: 'demo-trip',
  slug: 'rome-adventure-demo',
  title: 'Rome Adventure',
  description: 'An unforgettable week exploring the Eternal City.',
  destination: 'Rome, Italy',
  start_date: '2026-08-10',
  end_date: '2026-08-17',
  cover_url: null,
  points: [
    { id: 'p1', title: 'Colosseum', type: 'attraction', date: '2026-08-10',
      day_index: 0, address: 'Rome, Italy', description: 'Ancient gladiatorial arena',
      status: 'visited', lat: 41.89, lng: 12.49 },
    { id: 'p2', title: 'Vatican Museums', type: 'attraction', date: '2026-08-11',
      day_index: 1, address: 'Vatican City', description: 'Home of the Sistine Chapel',
      status: 'visited', lat: 41.906, lng: 12.453 },
    { id: 'p3', title: 'Trevi Fountain', type: 'attraction', date: '2026-08-12',
      day_index: 2, address: 'Rome, Italy', description: 'Make a wish',
      status: 'visited', lat: 41.900, lng: 12.483 },
    { id: 'p4', title: 'Pantheon', type: 'attraction', date: '2026-08-13',
      day_index: 3, address: 'Rome, Italy', description: '2000-year-old temple',
      status: 'planned', lat: 41.898, lng: 12.476 },
  ],
  media: [],
  stats: { day_count: 7, place_count: 4, photo_count: 0, country_count: 1 },
}

export async function getStory(slug: string): Promise<Story> {
  if (USE_MOCK_API) return MOCK_STORY
  // Public endpoint — no auth needed
  const res = await fetch(`${import.meta.env.VITE_API_URL ?? 'http://localhost:8093/api/v1'}/story/${slug}`)
  if (!res.ok) throw new Error('Story not found')
  return res.json()
}

export async function publishStory(
  tripId: string,
  isPublic: boolean,
): Promise<{ is_public: boolean; slug: string | null }> {
  if (USE_MOCK_API) return { is_public: isPublic, slug: isPublic ? 'rome-adventure-demo' : null }
  const res = await fetch(
    `${import.meta.env.VITE_API_URL ?? 'http://localhost:8093/api/v1'}/trips/${tripId}/story`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${(await import('./httpClient')).getToken()}`,
      },
      body: JSON.stringify({ is_public: isPublic }),
    },
  )
  if (!res.ok) throw new Error('Failed to update story visibility')
  return res.json()
}
